import styled from 'styled-components';
import { palette } from 'styled-tools';

import { Button, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

export const Wrapper = styled.section`
	margin-bottom: 20px;
	min-height: auto;

	${minWidth('mobileLarge')} {
		margin: 0 auto 40px;
		min-height: auto;
	}

	${minWidth('desktop')} {
		display: flex;
		flex-wrap: wrap;
		height: 670px;
		margin: 0 auto 60px;
		max-width: 1368px;
	}
`;

export const Column = styled.div`
	box-sizing: border-box;
	color: ${palette('white')};
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 0 80px;
	position: relative;
	text-align: left;
	width: 100%;

	${minWidth('desktop')} {
		width: 50%;
	}

	&:first-of-type {
		padding: 0;
		min-height: calc(100vw - 44px);

		${minWidth('desktop')} {
			min-height: 680px;
		}
	}

	&:last-of-type {
		background: linear-gradient(0deg, rgb(59, 190, 236) 0%, rgb(52, 120, 221) 100%);
		padding: 36px 18px;
		text-align: center;

		${minWidth('desktop')} {
			padding: 0 72px;
			text-align: left;
		}
	}
`;

export const Heading = styled.h1`
	${fontWeight(FontWeights.Light)};
	margin-bottom: 3.5px;

	${minWidth('mobileLarge')} {
		margin-bottom: 24px;
	}
`;

export const Copy = styled.p`
	margin-bottom: 24px;

	${minWidth('desktop')} {
		margin-bottom: 36px;
	}
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;

	${minWidth('tablet')} {
		justify-content: flex-start;
	}
`;

export const StyledButton = styled(Button)`
	&:first-of-type {
		margin-right: 32px;
	}
`;
